export default __webpack_public_path__ + "icons/mstile-150x150-c64ad374ee5317e0bdfa79484ffb1558.png";